var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.listClass},_vm._l((_vm.messageList),function(item,index){return _c('AppDescriptionItem',{key:index,attrs:{"message":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }